/**
 * AutoLISP runtime errors. Every user-visible failure surfaces as a
 * `; error: <message>` transcript line, never a thrown host crash.
 */
export class LispError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'LispError';
    }
}
